import {apiRequest} from "./API"

export default {
    // Submit MoveIn
    fetchMeterNumbers: async (unitNumber) => {
        let MeterNumbers = await apiRequest(`/meternum-by-unituuid?unitUuid=${unitNumber}`, "GET");
        return MeterNumbers;
    }
}